import { Box } from '@mentimeter/ragnar-ui/box';
import { WordCloud } from '@mentimeter/visualizations-react/visualizations/word-cloud';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { useRagnar } from '@mentimeter/ragnar-react';
import type { WordCloudData } from '../types';
import { useThrottledData } from './utils/use-throttled-data';

interface WordCloudVisualizationProps {
  shouldAnimate: boolean;
  shouldHideResults: boolean;
  results: Array<WordCloudData>;
  onRemoveWord: undefined | ((key: string) => void);
  textAccessibleColors: Array<string> | undefined;
}

export const WordCloudVisualization = ({
  shouldAnimate,
  shouldHideResults,
  results,
  onRemoveWord,
  textAccessibleColors,
}: WordCloudVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      fonts: { body },
    },
  } = useRagnar();

  const throttledData = useThrottledData<WordCloudData>(
    results,
    shouldAnimate ? 1800 : 0,
  );

  const colors =
    textAccessibleColors || (fillColors.length > 0 ? fillColors : [textColor]);

  return (
    <Box width="100%" height="100%" px="4%">
      <FullSizeContainer>
        {(width, height) => (
          <WordCloud
            width={width}
            height={height}
            colors={colors as [string, ...[string]]}
            textColor={textColor}
            data={throttledData}
            staticOptions={results}
            fontFamily={body}
            disableAnimations={!shouldAnimate}
            shouldMaskWords={shouldHideResults}
            onRemoveWord={onRemoveWord}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
